export default "<div style=\"width:auto;height:1400px;\" id=\"map\"></div>\r\n<!-- <leaflet-maps></leaflet-maps> -->\r\n";